import { connect } from 'react-redux'
import { selectCurrentTicketIsDelayed } from 'selectors/undoSend'
import View from './view'

const select = state => ({
  isDelayed: selectCurrentTicketIsDelayed(state),
})

export default connect(select, null)(View)
